import React from 'react';

const StarRating = ({ rating, size = 'md' }) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10'
  };

  const getStarColor = (index, rating) => {
    const fullRating = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;
    
    if (index < fullRating) {
      return '#00b67a';
    } else if (index === fullRating && hasHalf) {
      return '#00b67a';
    }
    return '#dcdce6';
  };

  const getBackgroundForRating = (r) => {
    if (r >= 4.5) return '#00b67a';
    if (r >= 4) return '#73cf11';
    if (r >= 3) return '#ffce00';
    if (r >= 2) return '#ff8622';
    return '#ff3722';
  };

  return (
    <div className="flex gap-0.5">
      {[0, 1, 2, 3, 4].map((index) => (
        <div
          key={index}
          className={`${sizes[size]} flex items-center justify-center`}
          style={{ backgroundColor: getBackgroundForRating(index < rating ? rating : 0) }}
        >
          <svg
            viewBox="0 0 24 24"
            className="w-[70%] h-[70%]"
            fill={index < Math.ceil(rating) ? (index < rating ? '#fff' : '#dcdce6') : '#dcdce6'}
          >
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        </div>
      ))}
    </div>
  );
};

export const TrustpilotStars = ({ rating, size = 'md' }) => {
  const sizes = {
    xs: 'h-4',
    sm: 'h-5',
    md: 'h-6',
    lg: 'h-8',
    xl: 'h-10'
  };

  const getStarsImage = (r) => {
    if (r >= 4.75) return 'stars-5';
    if (r >= 4.25) return 'stars-4.5';
    if (r >= 3.75) return 'stars-4';
    if (r >= 3.25) return 'stars-3.5';
    if (r >= 2.75) return 'stars-3';
    if (r >= 2.25) return 'stars-2.5';
    if (r >= 1.75) return 'stars-2';
    if (r >= 1.25) return 'stars-1.5';
    return 'stars-1';
  };

  return (
    <img
      src={`https://cdn.trustpilot.net/brand-assets/4.1.0/stars/${getStarsImage(rating)}.svg`}
      alt={`${rating} étoiles`}
      className={sizes[size]}
    />
  );
};

export const SingleStar = ({ filled = true, size = 'sm' }) => {
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <svg
      viewBox="0 0 24 24"
      className={sizes[size]}
      fill={filled ? '#00b67a' : '#dcdce6'}
    >
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  );
};

export default StarRating;
